var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 939 170",
        fill: _vm.fill,
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M248.96 3.0498H227.18V166.95H319.67V146.35H248.96V3.0498Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M486.84 3.0498H462.27L401.16 166.95H424.33L474.54 28.9098L524.78 166.95H547.96L486.84 3.0498Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M739.72 105.11C738.77 102.77 737.26 100.47 735.15 98.18C733.04 95.92 731.21 94.01 729.66 92.43C728.11 90.88 725.72 89.24 722.52 87.51C719.33 85.8 716.79 84.46 714.92 83.51C713.04 82.59 710.12 81.41 706.13 79.99C702.14 78.6 699.18 77.53 697.28 76.86C695.35 76.17 692.18 75.05 687.76 73.48C675.11 69.42 666.19 65.53 661.04 61.79C655.9 58.05 653.32 52.58 653.32 45.4C653.32 37.92 656.03 32 661.51 27.61C666.98 23.24 674.16 21.06 683.05 21.06C700.84 21.06 713.25 29.5 720.28 46.36L738.54 35.82C733.7 25.05 726.49 16.38 716.89 9.82C707.29 3.29 696.01 0 683.05 0C668.68 0 656.51 4.19 646.53 12.54C636.53 20.9 631.54 32.18 631.54 46.38C631.54 52.3 632.6 57.62 634.71 62.3C636.81 66.98 639.2 70.76 641.86 73.66C644.49 76.55 648.53 79.36 653.92 82.08C659.3 84.82 663.8 86.8 667.42 88.06C671.04 89.3 676.25 91.09 683.06 93.43C696.95 97.8 706.87 101.93 712.79 105.85C718.73 109.75 721.71 115.61 721.71 123.43C721.71 131.06 718.74 137.2 712.79 141.8C706.87 146.41 698.29 148.71 687.04 148.71C664.25 148.71 649.65 138.8 643.26 118.99L624.53 129.75C628.9 142.25 636.51 152.08 647.36 159.27C658.2 166.4 671.26 170 686.57 170C703.41 170 717.07 165.75 727.53 157.23C737.98 148.73 743.22 137.3 743.22 122.93C743.22 119.49 742.89 116.24 742.18 113.19C741.46 110.15 740.63 107.45 739.72 105.11Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M820.48 3.0498V23.6598H868.73V166.95H890.27V23.6598H938.73V3.0498H820.48Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M66.37 139.72L31.31 39.0598H8.25L53.93 166.95H78.51L137.28 3.0498H113.63L66.37 139.72Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M11.02 25.0898C17.1062 25.0898 22.04 20.156 22.04 14.0698C22.04 7.98362 17.1062 3.0498 11.02 3.0498C4.93382 3.0498 0 7.98362 0 14.0698C0 20.156 4.93382 25.0898 11.02 25.0898Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }